import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

interface OwnProps extends HTMLElement {
  hellobarText: string;
  variant?: 'generic' | 'babyblue' | 'darkgray' | 'crimsonred' | 'lightblue';
  dismissable?: boolean;
}

const OpHellobar = createWrapper<OwnProps>('op-hellobar');

/**
 * OpHellobar component wraps an OpHellobarWrapper component with configurable props.
 *
 * Use the 'content' slot to provide custom content that will be rendered within this component.
 *
 * Example:
 *
 * ```jsx
 * <OpHellobar variant="crimsonred" dismissable={true}>
 *    <div slot="content">
 *      <p>This is the custom content for my hellobar component.</p>
 *    </div>
 * </OpHellobar>
 * ```
 *
 * @param hellobarText The html to be rendered within this component
 * @param variant The type of Hellobar to display (optional)
 * @param dismissable Whether the Hellobar can be dismissed by the user (optional)
 */

export default OpHellobar;
